import {useQuery} from "@tanstack/react-query";
import _ from "lodash";
import {getAllFields} from "../services/fieldService";
import {OrderStatus} from "../types/domain/orderStatus";
import {useAtomValue} from "jotai";
import {showActiveFieldsAtom} from "../store/filterSelectionStore";
import {useCompany} from "./companiesHooks";

export const useActiveCompanyFields = () => {
    const company = useCompany();
    const companyId = company.data?.id;
    const showActiveFields = useAtomValue(showActiveFieldsAtom);

    return useQuery({
        queryKey: ["companyFields", companyId, showActiveFields],
        queryFn: async () => {
            if (!companyId) return {fields: [], mapByFarmId: {}, mapByOrderId: {}, mapByFieldId: {}};

            let allFields = await getAllFields({companyId});

            if (showActiveFields) {
                allFields = allFields.filter((item) => item.order?.state === OrderStatus.ACTIVE);
            }

            return {
                fields: allFields ?? [],
                mapByFarmId: _.groupBy(allFields, "farmId"),
                mapByOrderId: _.groupBy(allFields, "orderId"),
                mapByFieldId: _.keyBy(allFields, "id"),
            };
        },
        enabled: !!companyId,
    });
};
